// extracted by mini-css-extract-plugin
export default {"root":"AuthScreen_root__i5Mmt","Card":"AuthScreen_Card__Erfzv","CardContent_LangSwitcher":"AuthScreen_CardContent_LangSwitcher__MXF--"};